<!-- 首页 -->
<template>
  <div class="index" :style="'background-image:'+indexBackground+';background-size:'+indexBackgroundSize">
    <div class="content">
      <div class="index-l">
        <div class="today-add">
          <h-title :text="'今日新增'"></h-title>
          <div class="item-box">
            <div class="item">
              <span class="num">{{todayAddInfo.newShops}}</span>
              <span class="name">门店</span>
            </div>
            <div class="item">
              <span class="num aunt-num">{{todayAddInfo.newAunts}}</span>
              <span class="name">阿姨</span>
            </div>
            <div class="item">
              <span class="num product-num">{{todayAddInfo.newProducts}}</span>
              <span class="name">产品</span>
            </div>
          </div>
        </div>
        <div class="history-add">
          <h-title :text="'历史累计'"></h-title>
          <div class="item-box">
            <div class="item">
              <span class="num history-num">{{globalInfo.shops}}</span>
              <span class="name">门店</span>
            </div>
            <div class="item">
              <span class="num history-num">{{globalInfo.aunts}}</span>
              <span class="name">阿姨</span>
            </div>
            <div class="item">
              <span class="num history-num">{{globalInfo.products}}</span>
              <span class="name">产品</span>
            </div>
          </div>
        </div>
        <div class="active-user">
          <div class="item">
            <h-ring
              :text="'当日活跃占比'"
              :chartData="ringDataOne"
              :percentage="percentageOne"
            ></h-ring>
          </div>
          <div class="item">
            <h-ring
              :text="'活跃新用户占比'"
              :chartData="ringDataTwo"
              :percentage="percentageTwo"
            ></h-ring>
          </div>
        </div>
        <div class="store-add">
          <h-title :text="'新增门店走势图'"></h-title>
          <h-line
            :chartData="lineChartData"
          ></h-line>
        </div>
      </div>
      <div class="index-m">
        <h3>三个阿姨家盟实时统计</h3>
        <h-map
          :chartData="mapChartData"
        ></h-map>
        <h-list
          :signRankList="signRankList"
          :activeRankList="activeRankList"
        ></h-list>
      </div>
      <div class="index-r">
        <div class="data-picker">
          <el-date-picker
            v-model="dataValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="pickerData"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-select v-model="monthValue" placeholder="请选择">
            <el-option
              v-for="item in monthOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <h-histogram
          :chartData="histogramChartData"
          :storeList="storeList"
        ></h-histogram>
        <classify-ring
          :chartData="classifyChartData"
        ></classify-ring>
      </div>
    </div>
  </div>
</template>

<script>
import HTitle from '@/components/common/hTitle'
import HRing from '@/components/common/hRing'
import HLine from '@/components/common/hLine'
import HMap from '@/components/common/hMap'
import HList from '@/components/common/hList'
import HHistogram from '@/components/common/hHistogram'
import ClassifyRing from '@/components/common/classifyRing'

import tool from '@/utils/index'
export default {
  data () {
    return {
      todayAddInfo: {
        newShops: 0,
        newAunts: 0,
        newProducts: 0
      }, // 今日新增
      startDate: tool.parseTime(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), '{y}-{m}-{d}'), // 今日往前推七天的日期
      endDate: tool.getLineNowDate(), // 今日日期
      globalInfo: {
        shops: 0,
        aunts: 0,
        products: 0
      }, // 累计数据
      ringDataOne: {
        columns: [],
        rows: []
      }, // 当日活跃
      ringDataTwo: {
        columns: [],
        rows: []
      }, // 活跃新用户占比
      percentageOne: '0%', // 当日活跃百分比
      percentageTwo: '0%', // 活跃新用户百分比
      lineChartData: {
        columns: ['日期', '访问用户'],
        rows: []
      }, // 新增门店走势
      mapChartData: {
        columns: ['name', '门店数'],
        rows: []
      }, // 地图
      signRankList: [], // 签约数量排行
      activeRankList: [], // 活跃数量排行
      histogramChartData: {
        columns: ['日期', '活跃门店'],
        rows: []
      }, // 柱状图
      storeList: [], // 活跃门店排行
      dataValue: [], // 默认日期
      monthOptions: [
        {
          value: '1',
          label: '日'
        }
      ], // 单位日
      monthValue: '日', // 日

      indexBackground: 'url(' + require('static/images/echarts-bg.png') + ')', // 背景图
      indexBackgroundSize: 'cover', // 背景图覆盖模式
      choiceDate: '',
      pickerOptions: {
        // disabledDate (time) {
        // let curDate = (new Date()).getTime()
        // let three = 30 * 24 * 3600 * 1000
        // let threeMonths = curDate - three
        //   return time.getTime() > Date.now() || time.getTime() < threeMonths
        // },
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      }, // 限制最多选择一个月
      classifyChartData: {
        columns: ['value', 'name'],
        rows: []
      },
      timer4: null
    }
  },
  components: {
    HTitle,
    HRing,
    HLine,
    HMap,
    HList,
    HHistogram,
    ClassifyRing
  },
  created () {
    const that = this
    // 默认取七天
    that.dataValue = [
      that.startDate, that.endDate
    ]
    that.getInfo()
    that.timer4 = setInterval(() => {
      that.getInfo()
    }, 300000)
  },
  methods: {
    pickerData (e) {
      const that = this
      that.startDate = e[0]
      that.endDate = e[1]
      that.getInfo()
    },
    toPercent (num, total) {
      if (total === 0) {
        return '0%'
      } else {
        return (Math.round(num / total * 10000) / 100.00 + '%')
      }
    },
    getNewInfo () {
      const that = this
      that.signRankList = [
        {
          name: '上海市',
          count: 100,
          id: 1
        }, {
          name: '浙江省杭州市',
          count: 223,
          id: 2
        }
      ]
    },
    getInfo () {
      const that = this
      tool.requestAxios('/statistcs/page/data/monitor', {
        beginTime: that.startDate,
        endTime: that.endDate
      }).then(res => {
        if (res.code === 1) {
          let tempData = res.data
          that.todayAddInfo = tempData.today // 今日新增
          that.globalInfo = tempData.global // 累计数据
          // 活跃占比
          that.ringDataOne = {
            columns: ['name', 'value'],
            rows: [
              { 'name': '活跃', 'value': tempData.dailyActive.activeShops },
              { 'name': '不活跃', 'value': tempData.global.shops - tempData.dailyActive.activeShops }
            ]
          }
          that.percentageOne = that.toPercent(tempData.dailyActive.activeShops, tempData.global.shops)
          if (tempData.dailyActive.activeShops === 0) {
            tempData.dailyActive.activeShops = 1
          }
          that.ringDataTwo = {
            columns: ['name', 'value'],
            rows: [
              { 'name': '活跃', 'value': tempData.dailyActive.newShops },
              { 'name': '不活跃', 'value': tempData.dailyActive.activeShops - tempData.today.newShops }
            ]
          }
          that.percentageTwo = that.toPercent(tempData.dailyActive.newShops, tempData.dailyActive.activeShops)
          // 门店走势数据
          that.lineChartData.rows = that.lineList(tempData.shop.news)
          // 地图
          that.mapChartData.rows = that.mapList(tempData.sign.provinces)
          // 签约/活跃数量排行
          that.signRankList = that.signList(tempData.sign.top10Cities)
          that.activeRankList = that.signList(tempData.dailyActive.top10Cities)
          // 柱状图
          that.histogramChartData.rows = that.histogramList(tempData.shop.actives)
          // 活跃门店排行
          that.storeList = that.signList(tempData.shop.top10)
          // 产品分类
          that.classifyChartData.rows = that.classifyList(tempData.global.productCategory)
        } else {
          that.$message.error('获取实时统计数据失败')
        }
      })
    },
    lineList (arr) {
      let tempArr = []
      for (let date in arr) {
        tempArr.push({
          '日期': date,
          '新增门店': arr[date]
        })
      }
      return tempArr
    },
    mapList (arr) {
      let tempArr = []
      for (let date in arr) {
        if (date === '内蒙古自治区') {
          tempArr.push({
            'name': date.substr(0, 3),
            '门店数': arr[date]
          })
        } else {
          tempArr.push({
            'name': date.substr(0, 2),
            '门店数': arr[date]
          })
        }
      }
      return tempArr
    },
    signList (arr) {
      let tempArr = []
      let count = 0
      for (let date in arr) {
        tempArr.push({
          'name': (count + 1) + '、' + date,
          'count': arr[date],
          'id': count
        })
        count++
      }
      return tempArr
    },
    histogramList (arr) {
      let tempArr = []
      for (let date in arr) {
        tempArr.push({
          '日期': date,
          '活跃门店': arr[date]
        })
      }
      return tempArr
    },
    classifyList (arr) {
      let tempArr = []
      for (let date in arr) {
        tempArr.push({
          'value': arr[date],
          'name': date
        })
      }
      return tempArr
    }
  }
}
</script>

<style lang='stylus' scoped>
.index
  height 100%
  .content
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    .index-l
      height 100%
      display flex
      flex-direction column
      justify-content center
      align-items center
      .today-add, .history-add
        width 358px
        height 144px
        // box-shadow 0 -2px 10px 0 #3dbdc4, inset 0 2px 6px 0 #3dbdc4
        border-radius 8px
        margin 20px
        border 1px solid #3DBDC4
        background #0C1530
        .item-box
          display flex
          justify-content space-around
          align-items center
          .item
            flex 1
            display flex
            flex-direction column
            justify-content center
            align-items center
            .num
              height 18px
              line-height 18px
              font-size 18px
              color #D5FF1E
              margin-bottom 17px
              font-weight 600
            .aunt-num
              color #FFC320
            .product-num
              color #FF3A5E
            .history-num
              color #44F0FF
            .name
              height 14px
              line-height 14px
              font-size 14px
              color #fff
      .history-add
        margin 16px 20px 36px
      .active-user
        width 358px
        height 116px
        background #0C1530
        border 1px solid #3DBDC4
        // box-shadow 0px 0px 20px 0px #3dbdc4
        border-radius 8px
        padding 22px 0
        display flex
        justify-content space-around
        align-items center
        margin-bottom 16px
        .item
          flex 1
      .store-add
        width 358px
        // box-shadow 0px 0px 20px 0px #3dbdc4
        border-radius 8px
        margin 20px
        border 1px solid #3DBDC4
        background #0C1530
    .index-m
      height 100%
      width 600px
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin 0 60px
      h3
        height 26px
        line-height 26px
        color #fff
        font-size 26px
        margin 40px 0 20px
    .index-r
      width 368px
      height 100%
      display flex
      flex-direction column
      justify-content center
      align-items flex-start
      padding 0 22px
      .data-picker
        height 40px
        margin 0 0 20px
        width 100%
        display flex
        justify-content center
        align-items center
</style>



// WEBPACK FOOTER //
// src/pages/index.vue